export default __webpack_public_path__ + "static/media/foxify-bg.ca5b913c.jpg";